// import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import Login from "../pages/login/Login";
import Layout from "./layout";
// import Loading from "./Loading";
import Error from "../pages/404";
import Account from "../pages/Account";
import FileAnalysis from "../pages/files/FileAnalysis";
import FileById from "../pages/files/FileById";
import LastSavedFile from "../pages/files/LastSavedFile";
import NewFile from "../pages/files/NewFile";
import Deleted from "../pages/manage/Deleted";
import Files from "../pages/manage/Files";
import History from "../pages/manage/History";
import Registration from "../pages/registration/Registration";
import Registrationpg2 from "../pages/registration/Registrationpg2";
import Registrationpg3 from "../pages/registration/Registrationpg3";
import Registrationpg4 from "../pages/registration/Registrationpg4";
import Success from "../pages/registration/Success";
import Settings from "../pages/Settings";
import ProtectedPages from "./ProtectedPages";

const AppRouter = () => {
  return (
    <Router>
      {/* <Suspense fallback={<Loading />}> */}
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="registration" element={<Registration />} />
        <Route path="registrationPg2" element={<Registrationpg2 />} />
        <Route path="registrationPg3" element={<Registrationpg3 />} />
        <Route path="registrationPg4" element={<Registrationpg4 />} />
        <Route path="registrationSuccess" element={<Success />} />

        {/* Routes that need authentication */}
        <Route path="/" element={<ProtectedPages />}>
          <Route index element={<Home />} />
          <Route element={<Layout />}>
            <Route path="manage">
              <Route path="files" element={<Files />} />
              <Route path="history" element={<History />} />
              <Route path="deleted" element={<Deleted />} />
            </Route>

            <Route path="file">
              <Route path=":documentId" element={<FileById />} />
            </Route>
          </Route>

          <Route path="new" element={<NewFile />} />
          <Route path="last" element={<LastSavedFile />} />
          <Route path="file/:documentId/analysis" element={<FileAnalysis />} />

          <Route path="settings" element={<Settings />} />
          <Route path="account" element={<Account />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<Error />} />
      </Routes>
      {/* </Suspense> */}
    </Router>
  );
};

export default AppRouter;
